export default {
  "content": "<circle cx=\"19\" cy=\"4\" r=\"4\" fill=\"#EA3917\"/><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M13.341 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V9.197A5.972 5.972 0 0119 10a6.04 6.04 0 01-1-.083V11H6V9h9.682a6.03 6.03 0 01-1.154-1H6V6h7.341A5.99 5.99 0 0113 4c0-.701.12-1.374.341-2zM6 14h8v-2H6v2z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};